import { Form } from '@ant-design/compatible'

import ManageFertilizerForm from './ManageFertilizerForm'

export default Form.create({
  name: 'providerForm',
})(ManageFertilizerForm)
